import * as yup from 'yup';

export const useAddWantedTerminalsValidation = () => {
  const schema = yup.object().shape({
    idTkds: yup.array().min(1),
  });

  return { schema };
};
